import { Injectable } from '@angular/core';
import { QuestionnaireResult } from '../../../../../backend/server/data-models/questionnaire-result/questionnaire-result.model';
import { AbstractService } from '../../shared/AbstractService';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireResultService extends AbstractService<QuestionnaireResult> {

  constructor() {
    super("questionnaire-result");
  }

  get(id: string): Promise<QuestionnaireResult> {
    return new Promise<QuestionnaireResult>((resolve, reject) => {
      Meteor.call("questionnaire-result.get", id, (err, res) => {
        console.warn("questionnaire-result.get");
        if (!err) {
          resolve(res ? new QuestionnaireResult(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  listFillable(): Promise<QuestionnaireResult[]> {
    return new Promise<QuestionnaireResult[]>((resolve, reject) => {
      return Meteor.call("questionnaire-result.listFillable", (err, res: any[]) => {
        console.warn("questionnaire-result.listFillable");
        if (!err) {
          // console.warn(res);
          const result: QuestionnaireResult[] = [];
          res.forEach(data => {
            result.push(new QuestionnaireResult(data));
          });
          resolve(result);
        } else {
          // console.warn(err);
          reject(err);
        }
      });
    });
  }

  create(questionnaireId: string, scheduleOrder: number): Promise<QuestionnaireResult> {
    return new Promise<QuestionnaireResult>((resolve, reject) => {
      return Meteor.call("questionnaire-result.create", questionnaireId, scheduleOrder, (err, res) => {
        // console.warn("questionnaire-result.create");
        if (!err) {
          // console.warn(res);
          resolve(res ? new QuestionnaireResult(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  update(id: string, seq: number, data: QuestionnaireResult): Promise<QuestionnaireResult> {
    return new Promise<QuestionnaireResult>((resolve, reject) => {
      return Meteor.call("questionnaire-result.update", id, seq, data, (err, res) => {
        // console.warn("questionnaire-result.update");
        if (!err) {
          // console.warn(res);
          resolve(res ? new QuestionnaireResult(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  finish(id: string, seq: number, data: QuestionnaireResult): Promise<QuestionnaireResult> {
    return new Promise<QuestionnaireResult>((resolve, reject) => {
      return Meteor.call("questionnaire-result.finish", id, seq, data, (err, res) => {
        // console.warn("questionnaire-result.finish");
        if (!err) {
          // console.warn(res);
          resolve(res ? new QuestionnaireResult(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  cancel(id: string, seq: number): Promise<QuestionnaireResult> {
    return new Promise<QuestionnaireResult>((resolve, reject) => {
      return Meteor.call("questionnaire-result.cancel", id, seq, (err, res) => {
        // console.warn("questionnaire-result.cancel");
        if (!err) {
          // console.warn(res);
          resolve(res ? new QuestionnaireResult(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  revoke(id: string, seq: number): Promise<QuestionnaireResult> {
    return new Promise<QuestionnaireResult>((resolve, reject) => {
      return Meteor.call("questionnaire-result.revoke", id, seq, (err, res) => {
        // console.warn("questionnaire-result.revoke");
        if (!err) {
          // console.warn(res);
          resolve(res ? new QuestionnaireResult(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  suspend(id: string, seq: number): Promise<QuestionnaireResult> {
    return new Promise<QuestionnaireResult>((resolve, reject) => {
      return Meteor.call("questionnaire-result.suspend", id, seq, (err, res) => {
        // console.warn("questionnaire-result.suspend");
        if (!err) {
          // console.warn(res);
          resolve(res ? new QuestionnaireResult(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  resume(id: string, seq: number): Promise<QuestionnaireResult> {
    return new Promise<QuestionnaireResult>((resolve, reject) => {
      return Meteor.call("questionnaire-result.resume", id, seq, (err, res) => {
        // console.warn("questionnaire-result.resume");
        if (!err) {
          console.warn(res);
          resolve(res ? new QuestionnaireResult(res) : null);
        } else {
          // console.warn(err);
          reject(err);
        }
      });
    });
  }

  listAnswers(userId: string, questionnaireId: string): Promise<QuestionnaireResult[]> {
    return new Promise<QuestionnaireResult[]>((resolve, reject) => {
      return Meteor.call("questionnaire-result.listAnswers", userId, questionnaireId, (err, res: QuestionnaireResult[]) => {
        // console.warn("questionnaire-result.listAnswers");
        //console.log(userId + " - " + questionnaireId);
        if (!err) {
          res.forEach((item, idx) => res[idx] = new QuestionnaireResult(item));
          // console.warn(res);
          resolve(res);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }
}
